/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-list-container"><div class="unclaimed-area" v-if="(unclaimed.length||unlock.length)"><div class="unclaimed-title"><span class="title-text">可领取的优惠券</span><mpx-view @tap="receiveAllCoupon" class="unclaimed-btn" v-if="(unclaimed.length>0)">全部领取</mpx-view></div><coupon-item v-for="(item, index) in (unclaimed)" :couponData="(item)" @receiveSingleCoupon="receiveSingleCoupon" :isUnclaimed="(true)"/><coupon-item v-for="(item, index) in (unlock)" :couponData="(item)" @receiveSingleCoupon="receiveSingleCoupon" :isUnlock="(true)"/></div><div class="received-area" v-if="(received.length)"><div class="received-title"><span class="title-text">已领取的优惠券</span><span class="received-tip">满足使用条件即可使用</span></div><coupon-item v-for="(item, index) in (received)" :couponData="(item)" :isReceived="(true)"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m352bf834"}'>
  .coupon-list-container
    width 100%
    box-sizing border-box
    background #F6F8FB
    transform translateY(-20px)
    .title-text
      font-family PingFang SC
      font-size 14px
      font-weight 600
      color #333
    .received-area
      background #fff
      padding 20px 15px
      .received-title
        display flex
        align-items center
        padding-bottom 15px
        .received-tip
          font-family PingFang SC
          font-size 12px
          font-weight 400
          color #999
          margin-left 5px
    .unclaimed-area
      background #fff
      padding 20px 15px
      margin-bottom 7px
      .unclaimed-title
        display flex
        align-items center
        justify-content space-between
        margin-bottom 15px
        .unclaimed-btn
          width 85px
          height 27px
          border-radius 13.5px
          background linear-gradient(270deg, #FF4A4E 0%, #FF712E 100%)
          font-family PingFang SC
          font-size 13px
          font-weight 500
          line-height 11px
          color #fff
          display flex
          align-items center
          justify-content center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m352bf834"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex352bf834%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex352bf834%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m352bf834"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index352bf834/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-item':getComponent(require("./coupon-item/index.mpx?isComponent&outputPath=components%2Findex2fc57e1e%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
